module.exports = __webpack_public_path__ + "static/media/whyDoItIcon01.fb1d5a24.svg";